export default function (number: number) {
  return number.toLocaleString("en-US", {
    notation: "compact",
  });
}
